module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_rc-switch@1.9.0@rc-switch/es/index.js
// module id = 411
// module chunks = 0